import momenJalaali from "moment-jalali";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import DatePicker from "react-datepicker2";
import { Button, Card, Row } from "react-bootstrap";
import { useEffect, useRef, useState } from "react";
import BihamtaTable from "../../Components/BihamtaTable";
import { setDialog } from "../../store/api/GetAllProduct";
import ModalProducts from "../../Components/Modals/ModalProducts";
import ModalSelectUser from "../../Components/Modals/ModalSelectUser";
import ModalSearchStorage from "../../Components/Modals/ModalSearchStorage";
import { bomTypes, exportToExcel, isMobileApp, keyIsLetterOrNumber, setErrorDialog } from "../../store/api/CommonFunctions";
import { EyeFill, EyeSlashFill, FileEarmarkExcelFill, List, Printer, Search } from "react-bootstrap-icons";
import { searchBoM, deleteBoM, getStatusList } from "../store/api/ProductionAPI";
import { getSystemSettings } from "../../Sale/store/api/Invoice";
import { useHistory } from "react-router-dom";
import Loader from "react-loader-spinner";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBroom, faSearch } from '@fortawesome/free-solid-svg-icons';

const SearchBoM = () => {
    const frmFilters = useRef();
    const history = useHistory();
    const dispatch = useDispatch();
    const filterData = useSelector(state => state.ProductionReducer.bomSearchFilters)
    const [dateFilters, setDateFilters] = useState({
        FormDateFrom: filterData?.FormDateFrom,
        FormDateTo: filterData?.FormDateTo,
    });
    const { handleSubmit, register } = useForm();
    const [pending, setPending] = useState(false);
    const [createBy, setCreateBy] = useState(null);
    const [showFilter, setShowFilter] = useState(true);
    const [statusList, setStatusList] = useState();
    const [destStorage, setDestStorage] = useState(null);
    const [popUser, setPopUser] = useState({ show: false });
    const [selectedProduct, selectProduct] = useState(null);
    const [sourceStorage, setSourceStorage] = useState(null);
    const [popStorage, setPopStorage] = useState({ show: false });
    const [popProduct, setPopProduct] = useState({ show: false });
    const systemSettings = useSelector(state => state.SystemSettingsReducer.systemSettings);
    const settingNames = ["ProductGrouppingType", "ProductDefaultSalePrice", "ProductDefaultSalePriceLabel"];
    let productGrouppingType = 1;
    let pDefaultSalePrice = "";
    let pDefaultSalePriceLabel = "";
    if (Array.isArray(systemSettings)) {
        productGrouppingType = Number(systemSettings.find(s => s.SettingName === "ProductGrouppingType")?.SettingValue ?? 1);
        pDefaultSalePrice = systemSettings.find(s => s.SettingName === "ProductDefaultSalePrice")?.SettingValue ?? "";
        pDefaultSalePriceLabel = systemSettings.find(s => s.SettingName === "ProductDefaultSalePriceLabel")?.SettingValue ?? "";
    }

    const tableColes = [
        { colTitle: "ردیف", colName: "RowNumber", showInMobile: true },
        { colTitle: "نوع فرم", colName: "PBillType", showInMobile: true },
        { colTitle: "شماره فرم", colName: "Code", showInMobile: true },
        { colTitle: "تاریخ فرم", colName: "PFormDate", showInMobile: true },
        { colTitle: "مارک محصول", colName: "ProductModel", showInMobile: false },
        { colTitle: "نوع محصول", colName: "ProductName" },
        { colTitle: "مدل محصول", colName: "ProductModel" },
        { colTitle: "سریال محصول", colName: "ProductSerial" },
        { colTitle: "وضعیت", colName: "StatusTitle" },
        { colTitle: "توضیحات", colName: "Description", colType: "string", maxTextLength: 50 }
    ]
    const tableRowButtons = [
        { title: "نمایش فرم", type: "show", className: "group-Btn-smalll btn-secondary", onclick: rowClick, showCondition: () => isMobileApp() },
        {
            title: "چاپ فرم", type: "common", className: "group-Btn-smalll btn-primary", onclick: print, icon: <Printer color="#2727ff" size={18} className="rowBtn" />
        },
        {
            title: "حذف فرم", type: "delete", className: "group-Btn-smalll btn-danger", onclick: (item) => {
                dispatch(setDialog({
                    status: 'show',
                    arrayBtn: ['yes', 'no'],
                    dialogTitle: 'حذف فرم',
                    dialogText: 'آیا از حذف مطمئن هستید؟',
                    okOperation: () => deleteBoM(item.ID, onDelete)
                }))
            }
        }

    ]
    function onDelete(res) {
        if (res.Error) {
            setErrorDialog(dispatch, res.Error, "حذف فرم");
        }
        else if (res !== "PENDING") {
            dispatch(searchBoM(filterData));
        }
    }
    function showModalProduct(e) {
        if (e.key) {
            if (!keyIsLetterOrNumber(e.keyCode, e.key)) {
                return;
            }
            e.preventDefault();
        }
        filterData.ProductID = null;
        filterData.ProductName = null;
        filterData.ProductHolder = null;
        const setData = (data) => {
            selectProduct(data);
        }
        setPopProduct({ show: true, value: e.key, setProductData: setData, forStorageReport: true });
    }
    // function showModalStorage(e, fieldName) {
    //     if (e.key) {
    //         if (!keyIsLetterOrNumber(e.keyCode, e.key)) {
    //             return;
    //         }
    //         e.preventDefault();
    //     }
    //     if (fieldName === "DestStorage") {
    //         filterData.DestinationStorageID = null;
    //         filterData.DestinationStorageName = null;
    //     }
    //     else {
    //         filterData.SourceStorageID = null;
    //         filterData.SourceStorageName = null;
    //     }
    //     const onSelectStorage = (data) => {
    //         if (fieldName === "DestStorage") {
    //             setDestStorage(data);
    //         }
    //         else {
    //             setSourceStorage(data)
    //         }
    //     }
    //     setPopStorage({ show: true, setStorageData: onSelectStorage })
    // }
    function showCreateBy() {
        filterData.CreateById = null;
        filterData.CreateByName = null;
        setPopUser({ show: true, selectUserWithName: setCreateBy });
    }

    function search(data) {
        let formDateFrom = document.getElementsByName("FormDateFrom")[0].value;
        let formDateTo = document.getElementsByName("FormDateTo")[0].value;
        if (formDateFrom !== '') {
            data.FormDateFrom = dateFilters.FormDateFrom;
        }
        if (formDateTo !== '') {
            data.FormDateTo = dateFilters.FormDateTo;
        }
        data.Take = 10;
        data.Skip = 0;
        if (data.BillType)
            data.BillTypes = [data.BillType];
        dispatch(searchBoM(data));
    }
    function print(item) {
        history.push({
            pathname: `/PrintViewer/${Object.keys(bomTypes)[Number(item.BillType) - 1]}/false`,
            state: {
                dataUrl: `api/BoMAPI/GetBoM?id=${item.ID}`,
                method: "get"
            }
        });
    }
    function rowClick(item) {
        const produceOne = Number(item.ProductCount) > 1 ? 0 : 1;
        if (item.ctrlIsDown) {
            window.open(`/Production/BoM/${item.ID}/${Number(item.BillType)}/${produceOne}`);
        }
        else {
            history.push(`/Production/BoM/${item.ID}/${Number(item.BillType)}/${produceOne}`)
        }
    }
    function showHideFilter(hide) {
        const divFilters = document.getElementById("divFilters");
        if (hide) {
            divFilters.classList.add("hiddenRow");
            setShowFilter(false);
        }
        else {
            divFilters.classList.remove("hiddenRow");
            setShowFilter(true);
        }
    }
    function clearFilters() {
        frmFilters.current.reset();
        setDateFilters({
            FormDateFrom: null,
            FormDateTo: null,
        });
        setCreateBy(null);
        setDestStorage(null);
        setSourceStorage(null);
        selectProduct(null);
        dispatch(searchBoM({ Take: 10, Skip: 0 }));
    }
    function toExcel() {
        const url = "api/BoMAPI/SearchBoM";
        const searchArgs = { ...filterData };
        searchArgs.Skip = 0;
        searchArgs.Take = -1;
        setPending(true);
        exportToExcel("SearchBoM", searchArgs, url, "post", tableColes, () => setPending(false));
    }
    useEffect(() => {
        document.body.classList = "notMain";
        document.title = "بی همتا-تولید";
        dispatch(getSystemSettings(settingNames));
        getStatusList(setStatusList);
    }, []);
    return (
        <div className="container-fluid mt-2">
            <br />
            <Card>
                <Card.Header className="headerStyle">
                    <FontAwesomeIcon icon={faSearch} size="lg" />&nbsp;جستجوی فرم
                </Card.Header>
                <Card.Body className="bodyStyle" style={{ textAlign: "right" }}>
                    <ModalProducts popData={popProduct} setProductPopup={setPopProduct} productGrouppingType={productGrouppingType} defaultSalePrice={pDefaultSalePrice} defaultSalePriceLabel={pDefaultSalePriceLabel} />
                    <ModalSearchStorage popData={popStorage} setStoragePoup={setPopStorage} />
                    <ModalSelectUser popData={popUser} setUserPop={setPopUser} />
                    <form readOnly onSubmit={handleSubmit(search)} ref={frmFilters}>
                        <Row id="divFilters" className="rowBorder">
                            <div className="rowTitle">
                                فیلترهای جستجو
                                &nbsp;
                                {showFilter && <EyeSlashFill size={20} className="hoverIcon" style={{ cursor: "pointer", color: "#ca237e" }} onClick={() => showHideFilter(true)} />}
                                {!showFilter && <EyeFill size={20} className="hoverIcon" style={{ cursor: "pointer", color: "#ca237e" }} onClick={() => showHideFilter(false)} />}
                                {showFilter && <FontAwesomeIcon icon={faBroom} size="lg" style={{ cursor: "pointer", color: "#007e80" }} onClick={clearFilters} />}
                            </div>
                            <div className="col-md-2 form-group">
                                <label>نوع فرم:</label>
                                <select className="tableRowInput" name="BillType" ref={register({})} defaultValue={filterData?.BillType ?? ""}>
                                    <option value="">انتخاب کنید</option>
                                    <option value={bomTypes.BoM}>فرمول ساخت</option>
                                    <option value={bomTypes.ProductionEstimate}>برآورد تولید</option>
                                    <option value={bomTypes.ProductionInvoice}>فاکتور تولید</option>
                                </select>
                            </div>
                            <div className="col-md-2 form-group">
                                <label>شماره فرم از:</label>
                                <input type="text" className="tableRowInput" name="CodeFrom" ref={register({})} defaultValue={filterData?.CodeFrom ?? ""} />
                            </div>
                            <div className="col-md-2 form-group">
                                <label>شماره فرم تا:</label>
                                <input type="text" className="tableRowInput" name="CodeTo" ref={register({})} defaultValue={filterData?.CodeFrom ?? ""} />
                            </div>
                            <div className="col-md-2 form-group">
                                <label>وضعیت فرم:</label>

                                {statusList?.Data ?
                                    <select className="tableRowInput" name="StatusID" ref={register({})} defaultValue={filterData?.StatusID ?? ""}>
                                        <option value="">انتخاب کنید</option>
                                        {statusList.Data.map((st, i) => <option key={i} value={st.ID}>{st.StatusTitle}</option>)}
                                    </select>:
                                    <div className="tableRowInput">
                                        <Loader type="BallTriangle" color="#bb1370" width={25} height={25} style={{display:"inline-block"}}/>&nbsp;درحال بارگذاری
                                        </div>
                                }
                            </div>
                            {/* <div className="col-md-2 form-group">
                                <label>انبار مبدا:</label>
                                <input type="hidden" name="SourceStorageID" value={sourceStorage?.StorageID ?? filterData?.SourceStorageID ?? ""} ref={register({})} />
                                <input type="text" className="form-control" readOnly onKeyDown={e => showModalStorage(e, "SourceStorage")} name="SourceStorageName" ref={register({})}
                                    value={sourceStorage?.StorageName ?? filterData?.SourceStorageName ?? ""} />
                                <Button className="btn-input-tiny" onClick={e => showModalStorage(e, "SourceStorage")} style={{ top: 25 }}><List size={23} /></Button>
                            </div> */}
                            {/* <div className="col-md-2 form-group">
                                <label>انبار مقصد:</label>
                                <input type="hidden" name="DestinationStorageID" value={destStorage?.StorageID ?? filterData?.DestinationStorageID ?? ""} ref={register({})} />
                                <input type="text" className="form-control" readOnly onKeyDown={e => showModalStorage(e, "DestStorage")} ref={register({})} name="DestinationStorageName"
                                    value={destStorage?.StorageName ?? filterData?.DestinationStorageName ?? ""} />
                                <Button className="btn-input-tiny" onClick={e => showModalStorage(e, "DestStorage")} style={{ top: 25 }}><List size={23} /></Button>
                            </div> */}
                            <div className="col-md-2 form-group">
                                <label>محصول:</label>
                                <input type="hidden" name="ProductID" value={selectedProduct?.ProductID ?? filterData?.ProductID ?? ""} readOnly ref={register({})} />
                                <input type="text" className="tableRowInput" readOnly onKeyDown={showModalProduct} name="ProductName" ref={register({})}
                                    value={selectedProduct?.ProductName ?
                                        (selectedProduct?.HolderName + "-" + selectedProduct?.ProductName + "-" + selectedProduct.ProductModel) : filterData?.ProductName ?? ""} />
                                <Button className="btn-input-tiny" onClick={showModalProduct} style={{ top: 20 }}><List size={18} /></Button>
                            </div>
                            <div className="col-md-2 form-group">
                                <label>ثبت کننده:</label>
                                <input type="hidden" name="CreateByID" value={createBy?.ID ?? filterData?.CreateByID ?? ""} ref={register({})} />
                                <input type="text" className="tableRowInput" readOnly onKeyDown={showCreateBy} name="CreateByName" ref={register({})}
                                    value={createBy?.Name ?? filterData?.CreateByName ?? ""} />
                                <Button className="btn-input-tiny" onClick={showCreateBy} style={{ top: 20 }}><List size={18} /></Button>
                            </div>
                            <div className="col-md-2 form-group">
                                <label>سریال محصول:</label>
                                <input type="text" className="tableRowInput" name="ProductSerial" ref={register({})} defaultValue={filterData?.ProductSerial ?? ""} style={{ fontFamily: "Dark-Sans", fontSize: "11.5px" }} />
                            </div>
                            <div className="col-md-2 form-group">
                                <label>تاریخ ثبت از:</label>
                                <DatePicker isGregorian={false} timePicker={false} className="tableRowInput mt-0" name="FormDateFrom"
                                    value={dateFilters.FormDateFrom ? momenJalaali(dateFilters.FormDateFrom) : null}
                                    onChange={val => setDateFilters({ ...dateFilters, FormDateFrom: val.local("en").format("YYYY-MM-DD") })} />
                            </div>
                            <div className="col-md-2 form-group">
                                <label>تاریخ ثبت تا:</label>
                                <DatePicker isGregorian={false} timePicker={false} className="tableRowInput mt-0" name="FormDateTo"
                                    value={dateFilters.FormDateTo ? momenJalaali(dateFilters.FormDateTo) : null}
                                    onChange={val => setDateFilters({ ...dateFilters, FormDateTo: val.local("en").format("YYYY-MM-DD") })} />
                            </div>
                            <div className="col-md-2 form-group">
                                <label>توضیحات:</label>
                                <input type="text" className="tableRowInput" name="Description" ref={register({})} defaultValue={filterData?.Description ?? ""} />
                            </div>
                        </Row>
                        <Button type="submit" variant="secondary" className="group-Btn-large mt-2"><Search size={15} />&nbsp;جستجوی فرم</Button>
                    </form>
                    {!pending &&
                        <div style={{ padding: 0, width: "100%", textAlign: "left", marginTop: "1px" }}>
                            <FileEarmarkExcelFill onClick={toExcel} size={25} color="green" style={{ cursor: "pointer" }} className="hoverIcon" />
                        </div>}
                    {pending && <div style={{ padding: 0, width: "100%", textAlign: "left" }}><Loader type="BallTriangle" color="#bb1370" height={18} style={{ textAlign: "left", alignItems: "left" }} /></div>}
                    <BihamtaTable hasPaging={true} columns={tableColes} rowButtons={tableRowButtons} filterData={filterData} searchMethod={(data) => dispatch(searchBoM(data))}
                        reducerName="ProductionReducer" objectName="bomSearchList" rowClick={rowClick} style={{ whiteSpace: "nowrap" }} className="mt-1" />
                </Card.Body>
            </Card>
        </div>
    )
}
export default SearchBoM;